import { apiService } from './apiService';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://api.eternal-health.com/api';

export interface AdherenceStatistic {
  id: number;
  userId: number;
  weekStartDate: string;
  weekEndDate: string;
  totalDiaryItems: number;
  completedDiaryItems: number;
  adherencePercentage: number;
  createdAt: string;
  updatedAt: string;
}

export interface AdherenceFilters {
  start_date?: string;
  end_date?: string;
}

// Helper function to get date 10 weeks ago
const getTenWeeksAgo = (): string => {
  const date = new Date();
  date.setDate(date.getDate() - (10 * 7)); // 10 weeks * 7 days
  return date.toISOString().split('T')[0]; // Format as YYYY-MM-DD
};

// Helper function to get current date
const getCurrentDate = (): string => {
  return new Date().toISOString().split('T')[0]; // Format as YYYY-MM-DD
};

export const adherenceService = {
  /**
   * Get adherence statistics for a user
   * @param userId - The user ID to get statistics for
   * @param filters - Optional filters for date range
   * @returns Promise<AdherenceStatistic[]>
   */
  getAdherenceStatistics: async (
    userId: string | number, 
    filters?: AdherenceFilters
  ): Promise<AdherenceStatistic[]> => {
    // Build query parameters
    const params = new URLSearchParams();
    params.append('user_id', userId.toString());
    
    // If no filters provided, default to last 10 weeks
    if (!filters?.start_date && !filters?.end_date) {
      params.append('start_date', getTenWeeksAgo());
      params.append('end_date', getCurrentDate());
    } else {
      if (filters?.start_date) {
        params.append('start_date', filters.start_date);
      }
      if (filters?.end_date) {
        params.append('end_date', filters.end_date);
      }
    }

    const url = `${API_BASE_URL}/adherence-statistics/?${params.toString()}`;
    return await apiService.get(url);
  },

  /**
   * Get adherence statistics for the last 10 weeks
   * @param userId - The user ID to get statistics for
   * @returns Promise<AdherenceStatistic[]>
   */
  getLastTenWeeksAdherence: async (userId: string | number): Promise<AdherenceStatistic[]> => {
    return adherenceService.getAdherenceStatistics(userId, {
      start_date: getTenWeeksAgo(),
      end_date: getCurrentDate()
    });
  }
};
